queryMatches = (first, second) ->
  first.toLowerCase().indexOf( second.toLowerCase().trim() ) != -1

App.PromosEditController = Em.Controller.extend
  session: Em.inject.service()
  notifier: Em.inject.service()

  env:     Em.inject.service('environment')
  advertsEnabled: Em.computed.alias('env.features.advertsEnabled')
  promosEnabled: Em.computed.alias('env.features.promosEnabled')
  loyaltyEnabled: Em.computed.alias('env.features.loyaltyProgramsEnabled')
  clientTagsEnabled:   Em.computed.alias('env.features.enableClientTagAutoassign')
  bonusCategoriesEnabled:   Em.computed.alias('env.features.bonusCategories')

  needs: [ 'promos', 'promosIndex' ]

  sources: ['delivery_club', 'external_site', 'external_site_mobile', 'marketplace', 'marketplace_mobile', 'board', 'mobile_application_ios', 'mobile_application_android', 'foodfox', 'obed_ru', 'broniboy', 'chibbis', 'glovo', 'vk', 'sbermarket', 'yandex_lavka']
  recurrences: ['new', 'active', 'returned', 'cold', 'dead']

  restaurantsSortOrder: ['city','name']
  restaurants: Ember.computed.sort('controllers.promos.restaurants', 'restaurantsSortOrder')

  organizationBinding: 'promo.organization'

  promoBinding: 'model'

  promosIssues:  Em.computed.filterBy 'controllers.promosIndex.promos', 'issue_enabled', true

  clientTags: null
  currentTab: 'main'

  isLoading: false
  isPromoCodesCreating: false
  isPromoCodesDeleting: false
  isPromoCodesCreatingFormShown: false

  promoCodesAmount: null
  promoCodesLength: null

  dishesPage            : null
  dishesPageCount       : 0
  currentDishes         : Em.A([])
  isLoadingMoreDishes   : false

  isMainPage:        Em.computed.equal('currentTab', 'main')
  isConditionsPage:  Em.computed.equal('currentTab', 'conditions')
  isBonusesPage:     Em.computed.equal('currentTab', 'bonuses')

  canLoadMoreDishes: (->
    @get('dishesPage') < @get('dishesPageCount')
  ).property('dishesPage', 'dishesPageCount')

  has_promo_codes_unused: ( ->
    @get('promo.promo_codes_unused') > 0
  ).property('promo.promo_codes_unused')

  has_promo_codes: ( ->
    @get('promo.promo_codes_available') > 0
  ).property('promo.promo_codes_available')

  bonusTagCollection: (->
    Em.A _.compact([ @get('promo.bonus_client_tag.content') ])
  ).property('promo.bonus_client_tag', 'promo.bonus_client_tag.content')


  isPromoCodesCreatingDisabled: (->
    @get('promoCodesAmount') <= 0 or @get('promoCodesLength') < 3
  ).property('promoCodesAmount','promoCodesLength')

  actions:
    onPromoCodesAmountChanged: (p)->
      @set('promoCodesAmount', p)

    isPromoCodesCreatingFormShownToggle: (p)->
      @set('isPromoCodesCreatingFormShown', !@get('isPromoCodesCreatingFormShown'))

    onPromoCodesLengthChanged: (p)->
      @set('promoCodesLength', p)

    addSource: (source)->
      v = @get('promo.sources_array').map((x) => x)
      v.push source
      @get('promo').set('sources_array', v)

    removeSource: (source)->
      v = @get('promo').get('sources_array')
      v = v.filter (s) =>
        s != source
      @get('promo').set('sources_array', v)

    addRecurrence: (recurrence)->
      v = @get('promo.recurrences_array').map((x) => x)
      v.push recurrence
      @get('promo').set('recurrences_array', v)

    removeRecurrence: (recurrence)->
      v = @get('promo').get('recurrences_array')
      v = v.filter (s) =>
        s != recurrence
      @get('promo').set('recurrences_array', v)

    createPromoCodes: ->
      promo = @get('promo')
      @set('isPromoCodesCreating', true)
      promo.nonRESTAction('POST', 'create_promo_codes', {amount: @get('promoCodesAmount'), length: @get('promoCodesLength')})
      .then =>
        @set('isPromoCodesCreating', false)
        @get('notifier').pushNotification
          type:     'success'
          # todo i18n
          message:  'Формирование промокодов завершено'
          duration: 5000
        promo.reload()
      .catch =>
        @set('isPromoCodesCreating', false)
        @get('notifier').pushNotification
          type:     'error'
          # todo i18n
          title:    'Ошибка'
          message:  'Произошла ошибка при формировании кодов'


    exportPromoCodes: ->
      adapter = @get('store').adapterFor('promo')
      token   = @get('session.apiKey')

      url = adapter.buildURL('promo', @get('promo.id'))

      queryParams = Em.$.param( token: token )

      csvLink = "#{url}/promo_codes_usage.csv?#{queryParams}"
      window.open(csvLink, '_blank')
      false

    viewPromoCodes: ->
      adapter = @get('store').adapterFor('promo')
      token   = @get('session.apiKey')

      url = adapter.buildURL('promo', @get('promo.id'))

      queryParams = Em.$.param( token: token )

      csvLink = "#{url}/promo_codes_usage.html?#{queryParams}"
      window.open(csvLink, '_blank')
      false

    deleteUnusedPromoCodes: ->
      # todo i18n
      return unless confirm 'Удалить неиспользованные коды?'
      promo = @get('promo')
      @set('isPromoCodesDeleting', true)
      promo.nonRESTAction('POST', 'delete_unused_promo_codes')
      .then =>
        @set('isPromoCodesDeleting', false)
        @get('notifier').pushNotification
          type:     'success'
          # todo i18n
          message:  'Неиспользованные коды удалены'
          duration: 5000
        promo.reload()
      .catch =>
        @set('isPromoCodesDeleting', false)
        @get('notifier').pushNotification
          type:     'error'
          # todo i18n
          title:    'Ошибка'
          message:  'Произошла ошибка при удалении кодов'



    toggleTimetableEnabled: ->
      @get('promo').toggleProperty('timetable_enabled')
      false

    queryCodes: (defer) ->
      defer.resolve([])

    removeCode: (code) ->
      promo = @get('promo')
      promo.get('codes').then (codes) =>
        codes.removeObject(code)

        code.get('promo').then =>
          code.destroyRecord()
      false

    createCode: (tag) ->
      promo = @get('promo')

      if promo.get('isNew')
        # todo i18n
        return alert 'Сохраните акцию перед добавлением кодов'

      promo.get('codes').then (codes) =>
        samePromos = codes.filter (code) => code.get('code') is tag

        if samePromos.length <= 0
          promoCode = @store.createRecord 'promoCode',
            code: tag
            promo: @get('promo')

          promoCode.save()
      false

    cancel: ->
      promo = @get('promo')

      if promo.get('isDirty') or promo.get('isNew')
        # todo i18n
        return unless confirm 'Отменить изменения?'
        promo = @get('promo')
        promo.rollback()

      @send('goBackToPromoList')

      false

    deletePromo: ->
      # todo i18n
      return unless confirm Em.I18n.t 'promos.confirm.delete'

      promo = @get('promo')
      promo.destroyRecord()
      .then =>
        @transitionToRoute('promos')

      false

    savePromo: ->
      promo = @get('promo')

      wasNew = promo.get('isNew')

      @set('isLoading', true)
      promo.save()
      .then =>
        @set('isLoading', false)
        @transitionToRoute('promos') if wasNew

      false

    assignBonusTag: (tag) ->
      @set('promo.bonus_client_tag', tag)
      false

    removeBonusTag: (tag) ->
      @set('promo.bonus_client_tag', null)
      false

    queryClients: (defer, query) ->
      organization = @get('organization')

      @store.find('client', search: query)
      .then(defer.resolve, defer.reject)

      false

    queryCategories: (defer, query) ->
      organization = @get('organization')

      @store.find('category', search: query)
        .then(defer.resolve, defer.reject)

      false

    queryDishes: (defer, query) ->
      @set('isLoadingMoreDishes', true)
      @store.find('dish', search: query)
        .then((dishes) =>
          # Установить данные в currentDishes
          @set('dishesPageCount', dishes.meta.page_count)
          @set('dishesPage', dishes.meta.page)
          @set('currentDishes', dishes)
          @set('isLoadingMoreDishes', false)
          # Затем выполнить defer.resolve с currentDishes
          defer.resolve(@get('currentDishes'))
        , defer.reject)

      false

    queryTags: (defer, query) ->
      organization = @get('organization')

      tagsPromise = if @get('clientTags')
        Em.RSVP.resolve( @get('clientTags') )
      else
        @store.find('client_tag', organization_id: organization.get('id'))

      tagsPromise
      .then (tags) =>
        @set('clientTags', tags)
        Em.RSVP.resolve(tags.filter (tag) => queryMatches(tag.get('name'), query))
      .then(defer.resolve, defer.reject)

      false

    loadMoreDishes: (query) ->
      if @get('canLoadMoreDishes') and not @get('isLoadingMoreDishes')
        @incrementProperty('dishesPage')
        @set('isLoadingMoreDishes', true)
        @store.find('dish', _.merge({page: @get('dishesPage'), search: query}))
          .then (dishes) =>
            @set('isLoadingMoreDishes', false)
            @get('currentDishes').pushObjects(dishes.toArray())
      false
